/**
 * Customer HTML can appear in two places in the HTML hierarchy:
 *
 *  1. Outside Quickstart blocks, where it should receive reasonable styling.
 *     (This is currently not happening.)
 *
 *  2. Inside Quickstart blocks where customers supply HTML or Markdown, using
 *     the customer-html class. For example, see MarkdownBlock
 */
import {css, th} from 'quickstart/system'

export const inlineStyles = css`
  strong,
  b {
    font-weight: ${th('fontWeights.bold')};
  }

  em,
  i {
    font-style: italic;
  }

  a {
    ${th('links.default')};
  }
`

export const blockStyles = css`
  & {
    ${th('fonts.body')};
    ${th('ui.html')};
  }

  :when(.text-container[data-variant='wider']) & {
    ${th('ui.htmlWider')};
  }

  aside,
  blockquote,
  figure,
  hr,
  img,
  p,
  pre,
  video {
    margin: 0;
    padding: 0;
    ${th('spaceAfter.html')};
  }

  h1 {
    margin: 0;
    padding: 0;
    ${th('prose.h1')};
  }

  h2 {
    margin: 0;
    padding: 0;
    ${th('prose.h2')};
  }

  h3 {
    margin: 0;
    padding: 0;
    ${th('prose.h3')};
  }

  h4 {
    margin: 0;
    padding: 0;
    ${th('prose.h4')};
  }

  h5 {
    margin: 0;
    padding: 0;
    ${th('prose.h5')};
  }

  h6 {
    margin: 0;
    padding: 0;
    ${th('prose.h6')};
  }

  figure,
  img,
  video {
    max-width: 100%;
    @media (min-width: ${th('breakpoints.md')}) {
      max-width: 75%;
    }
  }

  figure {
    > img,
    > video {
      display: block; // avoid inline space between img and figcaption
      max-width: 100%; // don't double 75%
      margin-bottom: calc(${th('spaceAfter.imageCaption.marginBottom')} * 2);
    }
    figcaption,
    figcaption > p {
      ${th('fonts.ui')};
      ${th('prose.imageCaption')};
      color: ${th('colors.textColorMuted')};
    }
  }

  /* :where() to avoid pseudo-classes increasing specificity */
  button {
    ${th('buttons.base')};
    ${th('buttons.sizes.lg')};
    &:where(:first-of-type) {
      ${th('buttons.primary')};
      &:where(:focus) {
        ${th('buttons.focus.primary')};
      }
      &:where(:hover) {
        ${th('buttons.hover.primary')};
      }
    }
    &:where(:not(:first-of-type)) {
      ${th('buttons.secondary')};
      &:where(:focus) {
        ${th('buttons.focus.secondary')};
      }
      &:where(:hover) {
        ${th('buttons.hover.secondary')};
      }
    }
    &:where(:disabled) {
      ${th('buttons.disabled')};
      cursor: not-allowed;
    }
  }

  ${inlineStyles}
`
